<script setup lang="ts">
import { GpTextArea } from '@gportal/uikit';
import OrderSection from '../OrderSection.vue';
import ExternalLink from 'gpcore-uikit/components/Component.ExternalLink.vue';

const settings = defineModel<{
  userData: string;
}>({
  default: {
    userData: '',
  },
});

const { preTitle, title } = defineProps<{
  preTitle: string;
  title: string;
}>();
</script>

<template>
  <OrderSection :pre-title="preTitle" :title="title" is-done section-key="settings">
    <p class="tw-mb-4">
      Use this for
      <ExternalLink :url="`${$config.docs.url}/guides/user-data/`"> user data config </ExternalLink>
      during the post installation, to automate the configuration processes after the node is ready.
      Depending on the operating system, it supports CloudInit, Cloudbase-Init, Bash or PowerShell.
    </p>

    <GpTextArea
      class="tw-w-full"
      v-model="settings.userData"
      input-id="order-settings-userdata"
      name="userdata"
      :rows="10"
      label="User data script"
    />
  </OrderSection>
</template>

<style scoped></style>
